var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-home-wrap",style:({ background: _vm.background })},[_c('div',{staticClass:"back-home dfr flex-center",on:{"click":_vm.goBack}},[_c('van-icon',{attrs:{"name":"arrow-left","size":".66rem","color":"#cb9025"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }